import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

const MenuItem = ({
  to,
  collapseSidebar,
  uniqueId,
  name,
  icon
}) => {
  return (
    <Link
      to={to}
      className='flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 hover:text-primary dark:hover:bg-gray-700 group'
      data-tooltip-id={collapseSidebar ? uniqueId : ''}
      data-tooltip-content={name}
      data-tooltip-offset={20}
    >
      {icon}
      <Tooltip
        id={uniqueId}
        place='right'
        style={{
          backgroundColor: '#1d3d6f',
          color: 'white'
        }}
      />
      {!collapseSidebar && (
        <span className='ml-3 text-white group-hover:text-primary'>
          {name}
        </span>
      )}
    </Link>
  );
};

export default MenuItem;
